(() => {
  if (window.__biomBannerScrollBound) return;
  window.__biomBannerScrollBound = true;

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-biom-banner-scroll-next]");
    if (!trigger) return;

    event.preventDefault();

    const currentSection = trigger.closest(".shopify-section");
    let nextSection = currentSection ? currentSection.nextElementSibling : null;

    while (nextSection && nextSection.offsetParent === null) {
      nextSection = nextSection.nextElementSibling;
    }

    if (!nextSection) return;

    const prefersReducedMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    nextSection.scrollIntoView({
      behavior: prefersReducedMotion ? "auto" : "smooth",
      block: "start",
    });
  });
})();
